import React from 'react';
import { useTranslation } from 'react-i18next';

import * as formatters from '../../utils/formatters';
import { displayJackpotAmount } from '../../utils/formatters';
import { isTemplateZeta } from '../../utils/template';
import Sliders from '../sliders/Sliders';

function Jackpot({ jackpot, currency }: Readonly<{ jackpot: string; currency: string }>) {
    const { t } = useTranslation();

    return (
        <div>
            <Sliders oldcomponentid="results-page" sliderslug="results-page" />
            <div className="jackpot container-small jackpot-results w-100 text-center invisible" id="results-page">
                <p className="name font-bold">{t('prizes.jackpot')}</p>
                {isTemplateZeta() ? (
                    <p className={`jackpot-amount d-block font-black currency-${currency}`}>
                        {displayJackpotAmount(jackpot, currency)}
                    </p>
                ) : (
                    <p className={`jackpot-amount d-block font-black currency-${process.env.MIX_CURRENCY}`}>
                        {formatters.convertAmount(jackpot, currency)}
                    </p>
                )}
            </div>
        </div>
    );
}

export default Jackpot;
